var map = {
	"./de/buttons.json": 9811,
	"./de/dialogs.json": 2663,
	"./de/elements.json": 2938,
	"./de/music.json": 3813,
	"./de/shortcuts.json": 885,
	"./el/buttons.json": 632,
	"./el/dialogs.json": 566,
	"./el/elements.json": 784,
	"./el/music.json": 6084,
	"./el/shortcuts.json": 3183,
	"./en/buttons.json": 1004,
	"./en/dialogs.json": 7367,
	"./en/elements.json": 1558,
	"./en/help/help.json": 4692,
	"./en/music.json": 6361,
	"./en/shortcuts.json": 4638,
	"./fr/buttons.json": 252,
	"./fr/dialogs.json": 1364,
	"./fr/elements.json": 9336,
	"./fr/help/help.json": 9513,
	"./fr/music.json": 9910,
	"./fr/shortcuts.json": 2526,
	"./hr/buttons.json": 9852,
	"./hr/dialogs.json": 1410,
	"./hr/elements.json": 4165,
	"./hr/music.json": 7000,
	"./hr/shortcuts.json": 4569,
	"./it/buttons.json": 9197,
	"./it/dialogs.json": 3528,
	"./it/elements.json": 9052,
	"./it/music.json": 9892,
	"./it/shortcuts.json": 6053,
	"./sl/buttons.json": 7255,
	"./sl/dialogs.json": 529,
	"./sl/elements.json": 6708,
	"./sl/music.json": 4177,
	"./sl/shortcuts.json": 6294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3631;